/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AddressType model module.
 * @module model/AddressType
 * @version 1.0.0
 */
class AddressType {
    /**
     * Constructs a new <code>AddressType</code>.
     * Address types. Street, square, road...
     * @alias module:model/AddressType
     * @param name {String} 
     */
    constructor(name) { 
        
        AddressType.initialize(this, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name) { 
        obj['name'] = name;
    }

    /**
     * Constructs a <code>AddressType</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AddressType} obj Optional instance to populate.
     * @return {module:model/AddressType} The populated <code>AddressType</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AddressType();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
AddressType.prototype['id'] = undefined;

/**
 * @member {String} name
 */
AddressType.prototype['name'] = undefined;






export default AddressType;

